import React, { useEffect, useState } from "react";
import "./soulClub.css";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";
import soulClubImage from "../../assets/images/soul-club/sould_club_image.webp";

const SoulClub = () => {
	const { t } = useTranslation();
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		phone: "",
		message: "",
	});
	const [status, setStatus] = useState("");

	useEffect(() => {
		const observerOptions = { threshold: 0.1, rootMargin: "0px 0px -50px 0px" };
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) entry.target.classList.add("active");
			});
		}, observerOptions);

		const elementsToAnimate = document.querySelectorAll(".reveal");
		elementsToAnimate.forEach((el) => {
			if (el.getBoundingClientRect().top < window.innerHeight)
				el.classList.add("active");
			observer.observe(el);
		});
		return () => elementsToAnimate.forEach((el) => observer.unobserve(el));
	}, []);

	const getArray = (key) => {
		const data = t(key, { returnObjects: true });
		return Array.isArray(data) ? data : [];
	};

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const handleInquiry = (e) => {
		e.preventDefault();
		setStatus("sending");

		const templateParams = {
			subject_title: "✨ НОВО ЗАПИТВАНЕ ЗА SOUL CLUB",
			inquiry_type: "Soul Club Membership Inquiry",
			from_name: formData.name,
			from_email: formData.email,
			phone: formData.phone,
			message: formData.message,
		};

		emailjs
			.send(
				"service_n4kjhbf",
				"template_5hdvgub",
				templateParams,
				"vu-iLvSTPOKJQ0ckO",
			)
			.then(() => {
				setStatus("success");
				setFormData({ name: "", email: "", phone: "", message: "" });
				setTimeout(() => setStatus(""), 5000);
			})
			.catch(() => setStatus("error"));
	};

	return (
		<div className="soul-club-wrapper">
			<div className="soul-club-container">
				<header className="soul-header reveal">
					<h1>{t("soul_club.title")}</h1>
					<p className="subtitle">{t("soul_club.subtitle")}</p>
				</header>

				<section className="section intro-with-image reveal delay-1">
					<div className="portrait-container">
						<img
							src={soulClubImage}
							alt="Stanislava"
							className="soul-portrait"
						/>
					</div>
					<div className="intro-content">
						{getArray("soul_club.intro").map((line, index) => (
							<p key={index} className="intro-text">
								{line}
							</p>
						))}
					</div>
				</section>

				<hr className="divider reveal" />

				<section className="section reveal">
					<h2>{t("soul_club.what_is.title")}</h2>
					<div className="section-content">
						<p>{t("soul_club.what_is.desc")}</p>
						<ul className="not-list">
							{getArray("soul_club.what_is.not_list").map((item, index) => (
								<li key={index}>
									<span>❌</span> {item}
								</li>
							))}
						</ul>

						<div className="salon-desc">
							<p>{t("soul_club.what_is.desc2")}</p>
							<ul className="simple-bullet-list">
								{getArray("soul_club.what_is.features_list").map(
									(item, index) => (
										<li key={index}>{item}</li>
									),
								)}
							</ul>
						</div>

						<p className="highlight-box">{t("soul_club.what_is.highlight")}</p>
					</div>
				</section>

				<section className="section beige-bg reveal">
					<h2>{t("soul_club.who_is.title")}</h2>
					<p className="section-subtitle">{t("soul_club.who_is.subtitle")}</p>
					<ul className="check-list">
						{getArray("soul_club.who_is.list").map((item, index) => (
							<li key={index}>
								<span>✨</span> {item}
							</li>
						))}
					</ul>
					<p className="small-note">*{t("soul_club.who_is.note")}</p>
				</section>

				<section className="section reveal">
					<h2>{t("soul_club.how_it_works.title")}</h2>
					<p className="max-width-text">{t("soul_club.how_it_works.intro")}</p>

					<div className="flow-box">
						<h3>{t("soul_club.how_it_works.flow_title")}</h3>
						<ul className="flow-list">
							{getArray("soul_club.how_it_works.flow_list").map(
								(item, index) => (
									<li key={index}>✨ {item}</li>
								),
							)}
						</ul>
					</div>

					<div className="works-notes">
						<p className="note-text">{t("soul_club.how_it_works.note")}</p>

						<div className="disclaimer-box">
							<p>{t("soul_club.how_it_works.disclaimer")}</p>
						</div>

						<p className="vibe-text">{t("soul_club.how_it_works.vibe")}</p>
					</div>
				</section>

				<section className="section dark-bg reveal">
					<h2>{t("soul_club.benefits.title")}</h2>
					<div className="benefits-grid">
						{getArray("soul_club.benefits.list").map((item, index) => (
							<div key={index} className="benefit-card">
								{item}
							</div>
						))}
					</div>
					<p className="benefits-outro">{t("soul_club.benefits.outro")}</p>
				</section>

				<section className="section founder-section reveal">
					<h2>{t("soul_club.founder.title")}</h2>
					<div className="founder-content">
						<p>{t("soul_club.founder.text")}</p>
						<p className="founder-insight">
							<em>{t("soul_club.founder.insight")}</em>
						</p>
						<p className="founder-subtext">{t("soul_club.founder.subtext")}</p>
					</div>
				</section>

				<section className="section launch-section reveal">
					<h2>{t("soul_club.launch.title")}</h2>
					<div className="launch-details">
						<div className="launch-item">
							<span className="icon">🗓</span>
							<div>
								<strong>{t("soul_club.launch.date_label")}</strong>{" "}
								{t("soul_club.launch.date_value")}
							</div>
						</div>
						<div className="launch-item">
							<span className="icon">📍</span>
							<span>{t("soul_club.launch.location")}</span>
						</div>
					</div>
					<p className="launch-note">{t("soul_club.launch.note")}</p>
				</section>

				{/* FORM Section */}
				<section className="section inquiry-section reveal" id="join">
					<div className="invite-box">
						<h3>{t("soul_club.invite.title")}</h3>
						<p className="invite-intro">{t("soul_club.invite.text")}</p>

						{status === "success" && (
							<div className="status-banner success">
								<span>✅</span> {t("soul_club.invite.success_msg")}
							</div>
						)}
						{status === "error" && (
							<div className="status-banner error">
								<span>❌</span> {t("soul_club.invite.error_msg")}
							</div>
						)}

						<form onSubmit={handleInquiry} className="soul-form">
							<input
								type="text"
								name="name"
								placeholder={t("soul_club.invite.name_placeholder")}
								value={formData.name}
								onChange={handleChange}
								required
							/>
							<input
								type="email"
								name="email"
								placeholder={t("soul_club.invite.email_placeholder")}
								value={formData.email}
								onChange={handleChange}
								required
							/>
							<input
								type="tel"
								name="phone"
								placeholder={t("soul_club.invite.phone_placeholder")}
								value={formData.phone}
								onChange={handleChange}
								required
							/>
							<textarea
								name="message"
								placeholder={t("soul_club.invite.message_placeholder")}
								rows="4"
								value={formData.message}
								onChange={handleChange}
							></textarea>

							<button
								type="submit"
								className="submit-btn"
								disabled={status === "sending"}
							>
								{status === "sending"
									? t("soul_club.invite.sending")
									: t("soul_club.invite.btn")}
							</button>
						</form>
					</div>
				</section>
			</div>
		</div>
	);
};

export default SoulClub;
